import React from 'react';
import { Title, Text, Button, Container, Group } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <Container mt={80} mb={80} style={{ textAlign: 'center' }}>
      <Title order={1} size="h1" style={{ fontWeight: '900' }}>
        404
      </Title>
      <Title mt="lg" style={{ fontWeight: '900' }}>
        A página que você procura não existe
      </Title>
      <Group mt="lg" justify="center">
        <Text c="dimmed" size="lg" style={{ maxWidth: '500px' }}>
          Você talvez tenha digitado errado o endereço, ou essa página mudou de URL.
        </Text>
      </Group>
      <Group mt="lg" justify="center">
        <Link to="/">
          <Button variant="subtle" size="md">
            Voltar para o dashboard
          </Button>
        </Link>
      </Group>
    </Container>
  );
}
